export const signup = data => {
 const { name: fullName, email, password, confirmPassword, isAccepted } = data;
 return { fullName, email, password, confirmPassword, isAccepted };
};

export const signin = data => data;

export const passForgot = data => data;

export const passReset = data => {
 const { confirmPassword, token } = data;
 return { newPassword: confirmPassword, token };
};

export const googlesignup = data => {
 const { select_by, clientId, credential } = data;
 return { select_by, clientId, tokenId: credential };
};

export const routes = data => {
 const [paths, allow] = data;
 const { routes } = paths;
 return [routes, allow];
};

export const logout = () => false;
